import { useToast, Box, Text, Flex, Circle, chakra, Img } from '@chakra-ui/react';
import { WarningIcon } from '@chakra-ui/icons';
import { motion, isValidMotionProp } from 'framer-motion';
import ToastCheck from '@/assets/svg/toast-check.svg';
type ToastType = 'success' | 'error' | 'warning';

const MotionBox = chakra(motion.div, {
  shouldForwardProp: (prop) => isValidMotionProp(prop) || prop === 'children',
});

const useCustomToast = () => {
  const toast = useToast();

  const showToast = (type: ToastType, message: string) => {
    const toastStyles = {
      success: {
        bg: '#ffffffff',
        icon: (
          <Circle size="30px" bg="white">
            <Img src={ToastCheck} alt="Success" w="20px" h="20px" />
          </Circle>
        ),
      },
      warning: {
        bg: '#ffffffff',
        icon: (
          <Circle size="30px" bg="white">
            <WarningIcon color="#F2994A" />
          </Circle>
        ),
      },
      error: {
        bg: '#ffffffff',
        icon: (
          <Circle size="30px" bg="white">
            <WarningIcon color="#F04438" width={'20px'} height={'20px'} />
          </Circle>
        ),
      },
    };

    toast({
      duration: 2000,
      isClosable: true,
      position: 'top',
      variant: 'solid',
      render: () => (
        <MotionBox
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: '0.3' }}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          bg={toastStyles[type].bg}
          color="white"
          px={4}
          py={3}
          boxShadow="md"
          fontFamily={'primary'}
          border="1px"
          borderColor="border.default"
          borderRadius="xl"
          // Positioning to appear under the header right section
          position="fixed"
          top={{ base: '70px', lg: '70px' }} // Adjust based on your header height
          right={{ base: '16px', lg: '16px' }} // Match the header's right padding
          zIndex="1000"
          width="auto"
          maxWidth="400px"
        >
          <Flex alignItems="center" gap={3}>
            <Box>{toastStyles[type].icon}</Box>
            <Text fontSize="md" fontWeight="semibold" color={'text.primary'}>
              {message}
            </Text>
          </Flex>
        </MotionBox>
      ),
    });
  };

  return { showToast };
};

export default useCustomToast;
